"use strict";
module.exports = require("./ajax");
